function PendingSeedsOverlay({ pendingSeedsCount, onValidate }) {
  if (!pendingSeedsCount) return null

  return (
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
      <div className="bg-white/90 text-gray-700 text-sm px-4 py-1 rounded-full shadow">
        {pendingSeedsCount === 1 ? '1 graine au sol' : `${pendingSeedsCount} graines au sol`}
      </div>
      <button
        onClick={onValidate}
        className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-bold shadow-lg transition-all active:scale-95"
      >
        ✓ Valider et planter
      </button>
    </div>
  )
}

export default PendingSeedsOverlay
